import axios from 'axios';

const getResponses = faqId => axios.get(`faqs/${faqId}/responses`);

const syncResponses = (faqId, params) => {
  return axios.put(`faqs/${faqId}/responses`, params);
};

export { getResponses, syncResponses };
